/** Regras de gabarito (modo prova) — alinhado ao backend. */

export const DEFINITIVE_ANSWER_KEY_REQUIRED_MSG =
  'Cadastre e salve o gabarito definitivo completo no processo (Gabarito / folha de respostas) antes de conferir folhas, lançar notas ou rodar leitura automática da prova objetiva.';

export const processUsesAnswerSheet = (process) => Boolean(process?.exam_uses_answer_sheet);

export const processDefinitiveAnswerKeyReady = (process) => {
  if (!processUsesAnswerSheet(process)) return true;
  return Boolean(process?.exam_answer_key_definitive_ready);
};

/** Preliminar salvo (relatório 12). Recurso contra gabarito usa apenas o cronograma. */
export const processPreliminaryAnswerKeyReady = (process) => {
  if (!processUsesAnswerSheet(process)) return false;
  return Boolean(process?.exam_answer_key_preliminary_ready);
};
